document.addEventListener("DOMContentLoaded", function() {
    const tdElement = document.querySelector('.prislusensvi td');
    const phrases = tdElement.textContent.split(',');
    tdElement.textContent = '';

    phrases.forEach((phrase) => {
        const span = document.createElement('span');
        span.textContent = phrase.trim();
        span.classList.add('estateParams-tag');
        tdElement.appendChild(span);
    });
});